
import Ram from "../../../assets/outline/Ram.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RamIcon({ className, dataTestid = "RamIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ram data-testid={dataTestid} className={classes} {...rest} />
  );
}
